import { Badge } from '@mantine/core';

import type { StoryStatus } from '../gql/graphql';
import { STORY_STATUS_COLORS, useLabels } from '../labels';

export function StatusBadge({ status }: { status: StoryStatus }) {
  const labels = useLabels();

  return (
    <Badge color={STORY_STATUS_COLORS[status]} variant="light">
      {labels.storyStatus(status)}
    </Badge>
  );
}
